import {
  Activity,
  AlertCircle,
  AlertTriangle,
  AtSign,
  Award,
  BadgeCheck,
  Ban,
  Bell,
  Briefcase,
  Building,
  Building2,
  Calendar,
  Car,
  CheckCircle,
  ClipboardList,
  Clock,
  Cloud,
  Copy,
  CreditCard,
  DollarSign,
  DoorClosed,
  Eye,
  EyeOff,
  FileSignature,
  FileText,
  GitFork,
  GraduationCap,
  Handshake,
  HeartPulse,
  HelpCircle,
  Hospital,
  IdCard,
  ImageOff,
  Info,
  KeyRound,
  Link,
  Lock,
  LogOut,
  Mail,
  MapPin,
  MessageSquare,
  MessageSquareOff,
  Minus,
  Monitor,
  PenLine,
  Phone,
  Receipt,
  RotateCcw,
  Scale,
  Search,
  Server,
  Share2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Smartphone,
  Stethoscope,
  ThumbsDown,
  UserCheck,
  UserRound,
  Users,
  Volume2,
  Wifi,
  XCircle,
  Zap,
} from 'lucide-react';

const iconMap = {
  Activity,
  AlertCircle,
  AlertTriangle,
  AtSign,
  Award,
  BadgeCheck,
  Ban,
  Bell,
  Briefcase,
  Building,
  Building2,
  Calendar,
  Car,
  CheckCircle,
  ClipboardList,
  Clock,
  Cloud,
  Copy,
  CreditCard,
  DollarSign,
  DoorClosed,
  Eye,
  EyeOff,
  FileSignature,
  FileText,
  GitFork,
  GraduationCap,
  Handshake,
  HeartPulse,
  HelpCircle,
  Hospital,
  IdCard,
  ImageOff,
  Info,
  KeyRound,
  Link,
  Lock,
  LogOut,
  Mail,
  MapPin,
  MessageSquare,
  MessageSquareOff,
  Minus,
  Monitor,
  PenLine,
  Phone,
  Receipt,
  RotateCcw,
  Scale,
  Search,
  Server,
  Share2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Smartphone,
  Stethoscope,
  ThumbsDown,
  UserCheck,
  UserRound,
  Users,
  Volume2,
  Wifi,
  XCircle,
  Zap,
};

export default function LessonIcon({ name, size = 20, className = '' }) {
  const Icon = iconMap[name];
  if (!Icon) return null;
  return <Icon size={size} className={className} />;
}
